import { useQuery } from '@tanstack/react-query';
import { inventoryKeys } from './keys.js';
import { useInventoryClient } from './provider.js';
export function useOrganization(options) {
    const client = useInventoryClient();
    return useQuery({
        queryKey: inventoryKeys.organization(),
        queryFn: ({ signal }) => client.organizations.me(signal),
        staleTime: 5 * 60_000,
        ...options,
    });
}
export function useEntitlements(options) {
    const client = useInventoryClient();
    return useQuery({
        queryKey: inventoryKeys.entitlements(),
        queryFn: ({ signal }) => client.organizations.entitlements(signal),
        staleTime: 5 * 60_000,
        ...options,
    });
}
/**
 * Whether to RENDER a control. Not whether the caller is allowed to use it.
 *
 * Invariant 7 is unambiguous: hiding a control is not enforcement, and the server checks
 * every gated route regardless. Two consequences for a skin:
 *
 *   * a 403 can still arrive after this returned `enabled: true` — the plan may have
 *     changed, or a per-org flag may have revoked the feature — so the mutation's error
 *     path must handle `FeatureNotInPlanError` and not treat it as impossible;
 *   * never use this to decide whether to *send* a request that matters. It decides
 *     whether a button is worth showing.
 */
export function useFeature(feature) {
    const { data, isLoading } = useEntitlements();
    return {
        enabled: Boolean(data && !data.suspended && data.features.includes(feature)),
        loading: isLoading,
        suspended: Boolean(data?.suspended),
    };
}
export function useHealth(options) {
    const client = useInventoryClient();
    return useQuery({
        queryKey: inventoryKeys.health(),
        queryFn: ({ signal }) => client.organizations.health(signal),
        ...options,
    });
}
//# sourceMappingURL=organization.js.map